/* global axios */
import ApiClient from './ApiClient';

class CustomSurveysAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  async getModels() {
    return axios.get(`${this.url}survey_models`);
  }

  async getSurvey() {
    return axios.get(`${this.url}smart_surveys`);
  }

  async getSurveyById(id) {
    return axios.get(`${this.url}smart_surveys/${id}`);
  }

  async createModel(payload) {
    return axios.post(`${this.url}survey_models`, payload);
  }

  async sendMail(payload) {
    return axios.post(`${this.url}smart_surveys/send_mail`, payload);
  }

  async deleteSurvey(id) {
    return axios.delete(`${this.url}smart_surveys/${id}`);
  }

  async createSurvey(payload) {
    return axios.post(`${this.url}smart_surveys`, payload);
  }

  async updateSurvey(payload) {
    return axios.put(`${this.url}smart_surveys/${payload.uuid}`, {
      smart_surveys: payload,
    });
  }

  async updateModel(payload) {
    return axios.put(`${this.url}survey_models/${payload.uuid}`, payload);
  }

  async deleteModel(id) {
    return axios.delete(`${this.url}survey_models/${id}`);
  }

  async deleteResponse(id) {
    return axios.delete(`${this.url}smart_responses/${id}`);
  }

  async getEmbedScript(id, settings = {}) {
    return axios.get(`${this.url}smart_surveys/${id}/embed_script`, {
      params: { embed_settings: settings },
    });
  }
}

export default new CustomSurveysAPI();
